import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

function App() {
  const [lang, setLang] = useState("en");

  const t = {
    en: {
      header: "Start Your Real Estate Career Now — Work From Home",
      intro: "Join our team of professional real estate sales consultants. Work remotely, grow your income, and receive full training and support.",
      consultation: "Apply Now!",
      name: "Name",
      mobile: "Mobile Number",
      message: "Why do you want to join us?",
      send: "Send"
    },
    ar: {
      header: "ابدأ مسيرتك في مجال العقارات الآن — من المنزل",
      intro: "انضم إلى فريق مستشاري المبيعات العقارية لدينا. اعمل من المنزل، وطوّر دخلك، واحصل على تدريب كامل ودعم مستمر.",
      consultation: "انضم الآن!",
      name: "الاسم",
      mobile: "رقم الموبايل",
      message: "لماذا تريد الانضمام إلينا؟",
      send: "إرسال"
    }
  };

  return (
    <>
      <Helmet>
        <title>Real Estate Sales Consultants Recruitment</title>
        <meta name="description" content="Join our team as a real estate sales consultant. Work from home, earn high commissions, and receive full training." />
      </Helmet>

      <div
        className="app-container"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL + '/images/background.gif'})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          minHeight: '100vh',
          width: '100%',
          overflowX: 'hidden',
          color: 'white',
          fontFamily: 'Arial, sans-serif',
          padding: '20px',
          boxSizing: 'border-box'
        }}
      >
        {/* LANGUAGE SWITCH */}
        <div style={{ position: "absolute", top: 20, right: 20 }}>
          <button
            onClick={() => setLang(lang === "en" ? "ar" : "en")}
            style={{
              background: "rgba(0,0,0,0.6)",
              border: "1px solid white",
              padding: "8px 15px",
              borderRadius: "5px",
              color: "white",
              cursor: "pointer",
              fontSize: "14px"
            }}
          >
            {lang === "en" ? "AR" : "EN"}
          </button>
        </div>

        {/* HEADER */}
        <header
          style={{
            textAlign: 'center',
            padding: '30px 10px',
            fontSize: 'clamp(1.5rem, 5vw, 2rem)',
            fontWeight: 'bold',
            textShadow: '1px 1px 5px rgba(0,0,0,0.7)',
            wordWrap: 'break-word',
            direction: lang === "ar" ? "rtl" : "ltr"
          }}
        >
          {t[lang].header}
        </header>

        {/* INTRO */}
        <section
          style={{
            textAlign: 'center',
            maxWidth: '95%',
            margin: '20px auto',
            fontSize: 'clamp(1rem, 4vw, 1.1rem)',
            lineHeight: '1.6',
            textShadow: '0px 0px 6px rgba(0,0,0,0.7)',
            direction: lang === "ar" ? "rtl" : "ltr"
          }}
        >
          {t[lang].intro}
        </section>

        {/* FORM */}
        <section
          style={{
            background: 'rgba(0,0,0,0.6)',
            padding: '20px',
            width: '90%',
            maxWidth: '400px',
            margin: '30px auto',
            borderRadius: '10px',
            boxShadow: '0 0 15px rgba(0,0,0,0.5)',
            boxSizing: 'border-box'
          }}
        >
          <h2
            style={{
              textAlign: 'center',
              marginBottom: '20px',
              fontSize: 'clamp(1.2rem, 5vw, 1.5rem)',
              direction: lang === "ar" ? "rtl" : "ltr"
            }}
          >
            {t[lang].consultation}
          </h2>

          <form
            action="https://api.web3forms.com/submit"
            method="POST"
            style={{ direction: lang === "ar" ? "rtl" : "ltr" }}
          >
            <input type="hidden" name="access_key" value="f0a2a564-1033-467f-b29e-b702d7e5e5ab" />

            <input
              type="text"
              name="name"
              placeholder={t[lang].name}
              required
              style={{
                width: '100%',
                padding: '12px',
                marginBottom: '15px',
                borderRadius: '5px',
                border: 'none',
                color: 'black'
              }}
            />

            <input
              type="tel"
              name="mobile"
              placeholder={t[lang].mobile}
              required
              style={{
                width: '100%',
                padding: '12px',
                marginBottom: '15px',
                borderRadius: '5px',
                border: 'none',
                color: 'black'
              }}
            />

            <textarea
              name="message"
              placeholder={t[lang].message}
              required
              rows="4"
              style={{
                width: '100%',
                padding: '12px',
                marginBottom: '15px',
                borderRadius: '5px',
                border: 'none',
                color: 'black'
              }}
            />

            <button
              type="submit"
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: '#007bff',
                border: 'none',
                color: 'white',
                fontSize: 'clamp(0.9rem, 3vw, 1rem)',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              {t[lang].send}
            </button>
          </form>

          {/* WHATSAPP BUTTON */}
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <a
              href="https://wa.me/message/QB5OPRCZYMR6H1"
              target="_blank"
              style={{
                display: 'inline-block',
                background: '#25D366',
                padding: '10px 20px',
                borderRadius: '50px',
                textDecoration: 'none',
                color: 'white',
                fontWeight: 'bold',
                fontSize: '1rem'
              }}
            >
              <img 
                src={process.env.PUBLIC_URL + '/images/whatsapp.png'} 
                alt="WhatsApp" 
                style={{ width: '28px', verticalAlign: 'middle', marginRight: '10px' }}
              />
              WhatsApp
            </a>
          </div>
        </section>
      </div>
    </>
  );
}

export default App;
